import React from "react";

interface CustomTagProps {
  children: string;
  bacgroundColor: string;
}

export const CustomTag: React.FC<CustomTagProps> = (props) => {
  const style = { backgroundColor: props.bacgroundColor };
  return (
    <div style={style} className="custom-tag-gc">
      {props.children}
    </div>
  );
};
export default CustomTag;
